import(/* webpackMode: "eager", webpackExports: ["AddonCartOverview"] */ "/vercel/path0/components/bundles/addons/addon-cart-overview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollableContent"] */ "/vercel/path0/components/bundles/addons/scrollable-content.tsx");
